module.exports = __webpack_public_path__ + "img/CarImage.175c9a41.png";